/* eslint-disable no-restricted-syntax */
// PoC デモページ（このページ限定で no-restricted-syntax を無効化し日本語文言を許可）。
import { LegacyPortalAccountService } from "@spwn-portal/grpc";
import React, { useMemo, useState } from "react";

import { createCrossOriginPrivateConnectClient } from "../../utility/connectWeb";
import {
  contentStyle,
  Modal,
  pageContainerStyle,
  PrimaryButton,
  sectionStyle,
} from "./evojUi";
import { startggConfig, startggRegisterUrl } from "./startggConfig";
import { useStartggLink } from "./useStartggLink";

/**
 * start.gg 連携デモ（/evoj/entry）。
 * ① start.gg 連携 → ② 登録フォーム → ③ チケット購入（entry 有無で購入可否を出し分け）。
 */
export const EvojEntryPage: React.FC = () => {
  const { link, clear } = useStartggLink();
  const client = useMemo(
    () => createCrossOriginPrivateConnectClient(LegacyPortalAccountService),
    []
  );
  const [linking, setLinking] = useState(false);
  const [checking, setChecking] = useState(false);
  const [modalMessage, setModalMessage] = useState<string | null>(null);

  const startLink = async () => {
    setLinking(true);
    try {
      const res = await client.startStartggLink({
        redirectUri: startggConfig.redirectUri,
      });
      window.location.assign(res.authorizeUrl);
    } catch (e) {
      console.error(e);
      setModalMessage("連携の開始に失敗しました");
      setLinking(false);
    }
  };

  const purchaseTicket = async () => {
    if (!link) {
      return;
    }
    setChecking(true);
    try {
      const res = await client.getStartggEntryStatus({
        startggUserId: link.userId,
        startggGamerTag: link.username,
        tournamentId: startggConfig.tournamentId,
        eventId: startggConfig.eventId,
      });
      setModalMessage(
        res.entered
          ? "購入しました"
          : "購入条件を満たしていないため購入できません"
      );
    } catch (e) {
      console.error(e);
      setModalMessage("購入処理に失敗しました");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div style={pageContainerStyle}>
      <div style={contentStyle}>
        <h1>EVOJ × start.gg 連携</h1>

        <section style={sectionStyle}>
          <h2>① start.gg 連携</h2>
          {link ? (
            <React.Fragment>
              <p>
                連携済み：<strong>{link.username}</strong>（start.gg user.id:{" "}
                {link.userId}）
              </p>
              <PrimaryButton onClick={clear}>連携解除</PrimaryButton>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <p>未連携</p>
              <PrimaryButton onClick={startLink} disabled={linking}>
                {linking ? "リダイレクト中…" : "start.gg と連携する"}
              </PrimaryButton>
            </React.Fragment>
          )}
        </section>

        <section style={sectionStyle}>
          <h2>② start.gg で登録</h2>
          {startggConfig.tournamentSlug ? (
            <PrimaryButton
              onClick={() =>
                window.open(
                  startggRegisterUrl(),
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              start.gg で登録する（別タブ）
            </PrimaryButton>
          ) : (
            <p>REACT_APP_STARTGG_TOURNAMENT_SLUG が未設定です</p>
          )}
          <p style={{ fontSize: 12, color: "#666" }}>
            別タブで大会に登録して戻ると、③でチケット購入ができます。
          </p>
        </section>

        <section style={sectionStyle}>
          <h2>③ チケット購入</h2>
          <PrimaryButton onClick={purchaseTicket} disabled={!link || checking}>
            {checking ? "確認中…" : "チケット購入"}
          </PrimaryButton>
        </section>
      </div>

      <Modal
        open={modalMessage !== null}
        message={modalMessage ?? ""}
        onClose={() => setModalMessage(null)}
      />
    </div>
  );
};
